/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BluetoothIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABD0lEQVR4nOWVPU4DMRCFvdTQEtFzGCLt/LhYvUHhHkhptuUMcIWIA0A6GgR0UYBTENEDiby7IdFWWWKjSHmSZWlszzce22Pn9kqkdk+KZyLrJQGw2jw0Unv3fnCSDMCpILxyPl32UdPFDcD7i2MWm2y1E1LcsOCBqDhtA6pxsh6JvdYQvHSPVnDXLJ7lin4bEGxhrLKJPXUGFEVxyIpRBRF8k2D4ewaCYbA1Adwy85H7ozISXJLY1/oNatoPq12VZXngthV5O2PFx8o5PkkhLpZyRb8NyOVcY/jO6hTV+Y6aok0PmRWjMDfpNSXFY2cACa6TPrRNSwUL3qIVPf6vYsexI18qqXNXA8ZJv8yd1AISS/EuXkolSgAAAABJRU5ErkJggg==)
 */
export const BluetoothIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M11.62 2.08a1 1 0 0 1 1.09.21l5 5a1 1 0 0 1-.09 1.5L13.6 12l4.02 3.22a1 1 0 0 1 .09 1.49l-5 5A1 1 0 0 1 11 21v-6.92l-3.38 2.7a1 1 0 0 1-1.24-1.56L10.4 12 6.38 8.78a1 1 0 0 1 1.24-1.56L11 9.92V3a1 1 0 0 1 .62-.92Zm1.38 12 2.5 2-2.5 2.5v-4.5Zm0-4.16v-4.5l2.5 2.5-2.5 2Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
